import React from "react";
import logo from "../../assets/logo.png";
import { motion } from "framer-motion";

const Loading = () => {
  return (
    <div className="fixed inset-0 bg-gradient-to-br from-gray-900 to-black flex items-center justify-center overflow-hidden z-50">
      <div className="text-center z-10">
        {/* Logo glow */}

        {/* Brand name */}
        <motion.div
          className="mb-8"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 6 }}
        >
          <h1 className="text-5xl md:text-6xl font-bold text-white mb-2">
            Me<span className="text-orange-500">Phim</span>
          </h1>
          <p className="text-gray-400 text-lg font-light">
            Chào mừng bạn đến với thế giới điện ảnh
          </p>
        </motion.div>

        {/* Loading bars */}
        <motion.div
          className="flex justify-center mb-6"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 6 }}
        >
          <div className="flex space-x-1">
            {[0, 1, 2, 3].map((i) => (
              <motion.div
                key={i}
                className="w-1 bg-orange-500 rounded-full"
                animate={{
                  height: [16, 32, 16],
                  opacity: [0.5, 1, 0.5],
                }}
                transition={{
                  duration: 4,
                  repeat: Infinity,
                  delay: i * 0.2,
                  ease: "easeInOut",
                }}
              />
            ))}
          </div>
        </motion.div>

        {/* Progress line */}
        <motion.div
          className="w-48 h-0.5 bg-gray-800 rounded-full mx-auto overflow-hidden"
          animate={{ opacity: [0.5, 1, 0.5] }}
          transition={{ duration: 6, repeat: Infinity }}
        >
          <motion.div
            className="h-full bg-gradient-to-r from-orange-600 to-orange-400 rounded-full"
            animate={{
              x: [-192, 192],
            }}
            transition={{
              duration: 4,
              repeat: Infinity,
              ease: "easeInOut",
            }}
          />
        </motion.div>

        {/* Loading text */}
        <motion.p
          className="text-gray-500 text-sm mt-6 font-medium tracking-wide"
          animate={{ opacity: [0.5, 1, 0.5] }}
          transition={{
            duration: 6,
            repeat: Infinity,
            ease: "easeInOut",
          }}
        >
          ĐANG TẢI
        </motion.p>
      </div>

      {/* Ambient background glow */}
      <motion.div
        className="absolute top-1/4 left-1/2 w-96 h-96 bg-orange-500/5 rounded-full blur-3xl -translate-x-1/2"
        animate={{
          scale: [1, 1.2, 1],
          opacity: [0.3, 0.5, 0.3],
        }}
        transition={{
          duration: 6,
          repeat: Infinity,
          ease: "easeInOut",
        }}
      />
    </div>
  );
};

export default Loading;
